import { Button, Icon } from 'native-base'
import { Envelope } from 'phosphor-react-native'
import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { Alert, Linking } from 'react-native'

import { useConfig } from '../../../../context/config'
import theme from '../../../../design-system/theme'
import { isNative } from '../../../../util/platform'

export const EmailSupportButton = () => {
  const { t } = useTranslation()
  const { config } = useConfig()
  const supportEmail = config.partnerConfig?.supportProvider.info?.email

  const openEmail = useCallback(async () => {
    if (!supportEmail) {
      return
    }
    const supportEmailMailto = `mailto:${supportEmail}`
    if (await Linking.canOpenURL(supportEmailMailto)) {
      await Linking.openURL(supportEmailMailto)
    } else {
      console.log(`Cannot open the URL ${supportEmailMailto}`)
      if (isNative()) {
        Alert.alert(t('screens.support.contactUsByEmail', { email: supportEmail }))
      } else {
        // eslint-disable-next-line no-alert
        alert(t('screens.support.contactUsByEmail', { email: supportEmail }))
      }
    }
  }, [supportEmail, t])

  if (!supportEmail) {
    console.error('No support email found')
    return null
  }

  return (
    <Button
      variant="outline"
      onPress={openEmail}
      leftIcon={<Icon as={<Envelope color="currentColor" />} size="md" color={theme.colors.primary['500']} />}
    >
      Email
    </Button>
  )
}
